import React, { useState, useRef } from "react";
import ls from "local-storage";
import { MasterService } from "../../services";
import { toast } from "react-toastify";
import Loader from "../common/loader";

const ImageUploader = ({ endpoint, getBulkUploadHistory, file, setFile }) => {
  const imageRef = useRef(null);

  const [dragOver, setDragOver] = useState(false);
  const [errorNotification, setErrorNotification] = useState(null);
  const [loading, setLoading] = useState(false);

  // Sync local UI with parent file
  const currentFile = file;

  /** Drag Events **/
  const handleDragEnter = (e) => e.preventDefault();

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragOver(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragOver(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFile = e.dataTransfer.files[0];

    if (!droppedFile || droppedFile.type.split("/")[0] !== "text") {
      setErrorNotification("Not a csv File");
      setFile?.(null);
      setDragOver(false);
      return;
    }

    setErrorNotification(null);
    setFile?.(droppedFile);
    setDragOver(false);
  };

  /** File Input **/
  const handleAddImage = (e) => {
    e.preventDefault();
    const selectedFile = imageRef.current.files[0];

    if (!selectedFile || selectedFile.type.split("/")[0] !== "text") {
      setErrorNotification("Not a csv File");
      setFile?.(null);
      return;
    }

    setErrorNotification(null);
    setFile?.(selectedFile);
  };

  /** Cancel **/
  const handleCancelUpload = (e) => {
    e.preventDefault();
    if (imageRef.current) imageRef.current.value = "";

    setFile?.(null);
    setDragOver(false);
  };

  /** Upload **/
  const handleBulkUpload = async (e) => {
    e.preventDefault();

    if (!file) return;

    setLoading(true);

    const logged_data = ls.get("logged_data");

    if (
      logged_data?.token &&
      logged_data?.user_data?.user_id
    ) {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("logged_user_id", logged_data.user_data.user_id);

      try {
        const result = await MasterService.post(endpoint, formData, {
          "Content-Type": "multipart/form-data",
        });

        if (result.data.status === 200) {
          toast.success("Data uploaded");
          setFile?.(null);
          handleCancelUpload(e);
          getBulkUploadHistory?.();
        } else {
          toast.error(result.data.message || "Upload failed");
        }
      } catch (err) {
        toast.error("Upload error");
      }
    }

    setLoading(false);
  };

  /** UI **/
  const dragOverClass = dragOver
    ? "display-box drag-over"
    : "display-box";

  const uploadText = currentFile ? (
    <div className="upload-file-name">
      <div className="upload-file-img">
        <span className="suceess-icn">
          <i className="ic-check"></i>
        </span>

        <h4>
          {currentFile.name}
          <i
            onClick={handleCancelUpload}
            className="ic-clearclose"
          ></i>
        </h4>
      </div>

      <button
        onClick={handleBulkUpload}
        className="btn-line file-btn btn-primary"
      >
        Upload
      </button>
    </div>
  ) : (
    <div className="upload-txt">
      <h4>Drop Files Here to Upload</h4>
      <span>Only csv files are accepted</span>

      <div className="or-txt">or</div>

      <button
        className="btn-line file-btn btn-primary"
        onClick={() => imageRef.current?.click()}
      >
        Upload
      </button>
    </div>
  );

  return (
    <div className="image-uploader-wrapper">
      {loading && <Loader />}

      <div className={dragOverClass}>
        <div className="icon-text-box">
          <div className="upload-icon">
            <i className="ic-file-icon" />
          </div>

          <div className="upload-text">{uploadText}</div>

          {errorNotification && (
            <div className="error-notification">
              <p>{errorNotification}</p>
            </div>
          )}
        </div>

        {!currentFile && (
          <input
            type="file"
            ref={imageRef}
            className="upload-image-input"
            accept="text/csv"
            onDrop={handleDrop}
            onDragEnter={handleDragEnter}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onChange={handleAddImage}
          />
        )}
      </div>
    </div>
  );
};


const FileUpload = ({ endpoint, getBulkUploadHistory, file, setFile }) => {
  return (
    <div style={{ textAlign: "center" }}>
      <ImageUploader 
        endpoint={endpoint}
        getBulkUploadHistory={getBulkUploadHistory}
        file={file}
        setFile={setFile}
      />
    </div>
  );
};


export default FileUpload



